module.exports = __webpack_public_path__ + "img/common-file-text-warning.14c8a488.svg";